import { FC, createContext, useContext, useState, Dispatch, SetStateAction } from "react";
import {
    QueryState,
    initialQueryState,
    WithChildren,
    ID
} from "../../../../../../../../_metronic/helpers";
import { DLMSiteApplication } from "../../../../_models";


type DLMLabelObject = { 
    siteApplicationid: number
    assignRole: string
    assignedId: number
}

export type DLMLabellingListContextProps = { 
    sites: Array<DLMSiteApplication>
    workflow: string
    state: QueryState
    updateState: (updates: Partial<QueryState>) => void
    currentSite : DLMSiteApplication | null
    setCurrentSite : Dispatch<SetStateAction<DLMSiteApplication | null>>
    itemIDForDelete: ID,
    setItemIDForDelete: Dispatch<SetStateAction<ID>>
    itemIDForUpdate: ID,
    setItemIDForUpdate: Dispatch<SetStateAction<ID>>
    applicationOwnerId: number
    objectOption1? : DLMLabelObject | null
    setObjectOption1? : Dispatch<SetStateAction<DLMLabelObject | null>>
}

const initialDLMLabellingListContextProps  = {
    sites: [],
    workflow: '',
    state: initialQueryState,
    updateState: () => {},
    currentSite: null, 
    setCurrentSite: () => {}, 
    itemIDForDelete: undefined,
    setItemIDForDelete: () => {},
    itemIDForUpdate: undefined,
    setItemIDForUpdate: () => {},
    applicationOwnerId: 0,
    objectOption1: null,
    setObjectOption1: () => {},    
}

const DLMLabellingListContext = createContext<DLMLabellingListContextProps>(initialDLMLabellingListContextProps);

export type DLMLabellingListProps = {
    sites: Array<DLMSiteApplication>
    workflow: string
    applicationOwnerId: number
}

const DLMLabellingListContextProvider: FC<DLMLabellingListProps & WithChildren> = ({sites, workflow, applicationOwnerId, children}) => {
    const [state, setState] = useState<QueryState>(initialQueryState)
    const [currentSite, setCurrentSite] = useState<DLMSiteApplication | null>(null)

    const [itemIDForDelete, setItemIDForDelete] = useState<ID>();
    const [itemIDForUpdate, setItemIDForUpdate] = useState<ID>();
    const [objectOption1, setObjectOption1] = useState<DLMLabelObject | null>(null)

    const updateState = (updates: Partial<QueryState>) => {
        const updatedState = {...state, ...updates} as QueryState
        setState(updatedState)
    } 

    return(
    <DLMLabellingListContext.Provider value={{
        sites, 
        workflow,
        state, 
        updateState, 
        currentSite, 
        setCurrentSite,
        itemIDForDelete, setItemIDForDelete, 
        itemIDForUpdate, setItemIDForUpdate, 
        applicationOwnerId,
        objectOption1, setObjectOption1
    }}>
        {children}
    </DLMLabellingListContext.Provider>
    )
}

const useDLMLabellingListContext = () => useContext(DLMLabellingListContext);

export { DLMLabellingListContextProvider, useDLMLabellingListContext}